import { PlusIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';
//UI Components
import AccentTitle from '@/components/UI/AccentTitle';
import Badge from '@/components/UI/Badge';
import Button from '@/components/UI/Button';
//Features Components
import { AddCategoryFilterForm, CategoriesList, NewCategoryForm, NewSubCategoryForm } from '@/features/Category';

export const CategoryManagement = () => {
  const [categoryFilters, setCategoryFilters] = useState<{
    [key: string]: any;
  }>();

  const [filterBadges, setFilterBadges] = useState<
    {
      id: number;
      label: string;
      value: string | number;
    }[]
  >([]);
  const [showModal, setShowModal] = useState<{ [key: string]: boolean }>({
    newCategory: false,
    newSubCategory: false,
    addFilter: false,
  });

  const filterHandler = (filterData: any) => {
    const updatedFilterData: { [key: string]: string | number | undefined } = {};
    const categoryFiltersBadges: {
      id: number;
      label: string;
      value: string | number;
    }[] = [];
    Object.keys(filterData).forEach((fd: string) => {
      updatedFilterData[fd] = filterData[fd]?.id;
      if (filterData[fd]?.name) {
        const labelKey: { [key: string]: string } = {
          subGroupId: 'Sub Group',
          groupId: 'Group',
        };
        categoryFiltersBadges.push({
          id: filterData[fd]?.id,
          label: labelKey[fd],
          value: filterData[fd]?.name,
        });
      }
    });
    setCategoryFilters(updatedFilterData);
    setFilterBadges(categoryFiltersBadges);

    modalHandler('addFilter');
  };

  const removeFilterBadgeHandler = (badge: { id: number; label: string; value: string | number }) => {
    const updatedCategoryFilterBadges: {
      id: number;
      label: string;
      value: string | number;
    }[] = filterBadges.filter((bdg) => bdg.id !== badge.id);

    setFilterBadges(updatedCategoryFilterBadges);

    if (categoryFilters) {
      const updatedFilterData: {
        [key: string]: string | number | undefined;
      } = {
        ...categoryFilters,
      };
      Object.keys(categoryFilters).forEach((fd: string) => {
        if (badge.id === categoryFilters[fd]) {
          updatedFilterData[fd] = undefined;
        }
      });
      setCategoryFilters(updatedFilterData);
    }
  };

  const modalHandler = (modal: string) => {
    setShowModal((prevState) => ({
      ...prevState,
      [modal]: !prevState[modal],
    }));
  };

  return (
    <>
      <div className='flex justify-content justify-between items-center w-full'>
        <AccentTitle title='Category Management' />
        <Button
          btnStyle='btn-primary'
          type='button'
          label='Add Category'
          customClassName='mr-5'
          onClick={() => modalHandler('newCategory')}
        />
      </div>
      <section className='border-t'>
        <div className='flex gap-2 m-4 items-center'>
          <button
            onClick={() => modalHandler('addFilter')}
            className='p-2 rounded-md bg-gray-100 flex gap-1 items-center hover:bg-neutralColor-light cursor-pointer text-xs font-medium transition duration-300 ease-in-out'
          >
            <PlusIcon className='h-4 w-4' />
            <span>Add Filter</span>
          </button>
          {filterBadges?.map((bdg, index) => (
            <div key={index} className='capitalize'>
              <Badge badgeType='primary' text={`${bdg.label}: ${bdg.value}`} handleRemove={() => removeFilterBadgeHandler(bdg)} />
            </div>
          ))}
        </div>
        <CategoriesList filterData={categoryFilters} />
      </section>
      {showModal.newCategory && <NewCategoryForm handleModal={() => modalHandler('newCategory')} />}
      {/* TO DO: Might need to move to Categories table component depending upon UI design. Current, It's not configured to work */}
      {showModal.newSubCategory && <NewSubCategoryForm handleModal={() => modalHandler('newSubCategory')} />}
      {showModal.addFilter && <AddCategoryFilterForm handleModal={modalHandler} handleApplyFilter={filterHandler} />}
    </>
  );
};
